import React, { useMemo } from "react";
import { Keyboard, View } from "react-native";
import i18n from "utils/i18n";
import { useSelector } from "react-redux";
import { dataConstants } from "services/redux/data/constants";
import _ from "lodash";
import Form from "components/molecules/Form";
import { FormFieldsConstants } from 'utils/constants/form-constants';
import ThemedBlock from "components/atoms/ThemedBlock";
import HelperSetting from "utils/helper-setting";
import { settingsConstants } from "utils/constants/settings-constants";
import EmployeeValues from 'scenes/home/more/_functions/Employee'
import { TESTID } from '_shared/config/testID'
import HelperString from 'utils/helper-string'
import { ProfileStyles } from 'scenes/home/more/profile/styles/ProfileStyles'
import VStack from 'components/atoms/stack/VStack'
import { transportList } from 'utils/constants/transport-constants'

const CommuteTab = ({ setIsSaveDisabled, setError, onUpdate }) => {
	
	const _settings = useSelector( state => {
		return state.data[dataConstants.SETTINGS];
	} )
	const _employee = useSelector( state => {
		return state.data[dataConstants.EMPLOYEE];
	} );
	
	const onChange = ( data ) => {
		// Push it like that
		EmployeeValues.onChangeEmployee( data );
		
		// Check if the form is valid
		setError( 'address', data.address_postal_code === 'error' );
		
		onUpdate( data )
	}
	
	const data = {
		transport_kind: EmployeeValues.getEmployeeField( _employee, 'transport_kind' ),
		license_plate: EmployeeValues.getEmployeeField( _employee, 'license_plate' ),
		address_postal_code: EmployeeValues.getEmployeeField( _employee, 'address_postal_code', EmployeeValues.getEmployeeField( _employee, 'address.postal_code' ) ),
	}
	
	const formFields = useMemo( () => {
		const results = [];
		if( HelperSetting.isYes( settingsConstants.COMMUTE_ENABLE ) ) {
			results.push({
				name: 'transport_kind',
				label: i18n.t('form.fields.transport_kind.title'),
				hint: i18n.t('form.fields.transport_kind.description'),
				type: FormFieldsConstants.SELECT,
				options: _.map( transportList, name => {
					return (
						{
							value: name,
							label: i18n.t(`basic.transport.kind.${ name }`)
						}
					);
				})
			});
		}
		
		if( HelperSetting.isYes( settingsConstants.BOOKING_ENABLE_PARKING_LICENSE_PLATE ) ) {
			results.push({
				name: 'license_plate',
				label: i18n.t('form.fields.license_plate.title'),
				hint: i18n.t('form.fields.license_plate.description'),
				type: FormFieldsConstants.TEXT,
				props: {
					returnKeyType: 'done',
					onSubmitEditing: Keyboard.dismiss,
					testID: TESTID.HOME.MORE.PROFILE.LICENSE_PLATE_INPUT
				}
			});
		}
		
		if( HelperSetting.isYes( settingsConstants.COMMUTE_ENABLE ) ) {
			results.push({
				name: 'address_postal_code',
				label: i18n.t('form.fields.address.title'),
				hint: i18n.t('form.fields.address.description'),
				type: FormFieldsConstants.ADDRESS,
			});
		}
		
		return results;
	}, [ _settings ]);
	
	return (
		<VStack>
			<ThemedBlock
				key={ HelperString.hash( "more-profile-form", _employee ) }
				mediumPadding
				shadow>
				
				<View
					style={ ProfileStyles.profileInformation }>
					
					<Form
						values={ data }
						fields={ formFields }
						onChange={ onChange }
						hideSubmit={ true }
					/>
				</View>
			</ThemedBlock>
		</VStack>
	)
}

export default CommuteTab;
